/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Preview_Pane_PropertiesInputs */

const cs_import_preview_pane_properties = /** @type {(inputs: Import_Preview_Pane_PropertiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitosti`)
};

const en_import_preview_pane_properties = /** @type {(inputs: Import_Preview_Pane_PropertiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listings`)
};

/**
* | output |
* | --- |
* | "Listings" |
*
* @param {Import_Preview_Pane_PropertiesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_preview_pane_properties = /** @type {((inputs?: Import_Preview_Pane_PropertiesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Preview_Pane_PropertiesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_preview_pane_properties(inputs)
	return cs_import_preview_pane_properties(inputs)
});